import { ExareReason, ExareReasonDocs, GetServicesRefundInfoQuery, RefundInfoFragment } from '@websky/graphql';
import { AppFile } from '@shared/lib/file-upload';
import { ExchangeRefundModalData } from '@entities/order';

export interface RefundState {
	refundInfo: RefundInfoFragment | null;
	gdsServicesRefundInfo: GdsServicesRefundInfoState;
	passengers: RefundPassengersState;
	selectedReason: RefundSelectedReasonState | null;
	documents: RefundDocumentsState | null;
	loading: RefundLoadingState;
	modal: ExchangeRefundModalData | null;
}

export type RefundOperation = 'updateOrder' | 'create' | 'refuse' | 'confirm' | 'documents' | 'services';

export type RefundLoadingState = Set<RefundOperation>;

export type AnyStateWithRefund<T = {}> = T & {
	refund: RefundState;
};

export enum ReasonCategory {
	Voluntary = 'Voluntary',
	Involuntary = 'Involuntary'
}

export enum VoluntaryReason {
	PlansChanged = 'PlansChanged'
}

export type RefundReason = ExareReason | VoluntaryReason;

export interface SelectedReasonInfo {
	category: ReasonCategory;
	reason: RefundReason;
	docs: ExareReasonDocs[];
}
export interface RefundSelectedReasonState {
	category: ReasonCategory;
	reason: RefundReason;
	docs: ExareReasonDocs[];
}

export interface ReasonWitchChecked {
	title: string;
	checked: boolean;
	value: RefundReason;
	docs: ExareReasonDocs[];
}

export interface ReasonGroup {
	category: ReasonCategory;
	title: string;
	reasons: ReasonWitchChecked[];
}

export interface RefundDocumentsState {
	[passengerId: string]: AppFile[];
}

export interface RefundPassengerDocument {
	passengerId: string;
	passengerFullName: string;
	documentType: ExareReasonDocs;
	files: AppFile[];
}

export type GdsServicesRefundInfoState = GetServicesRefundInfoQuery['GetGdsServicesRefundInfo']['gdsServicesRefundInfo'];

export interface RefundRequestDocument {
	passengerName: string;
	documentType: ExareReasonDocs;
}

export type RefundPassengersState = {
	[passengerId: string]: boolean;
};
